import React from "react";
import {
  defineBlock,
  smartProps,
  EditableDiv,
} from "@smartfire/gutenberg-react";
import style from "./block.module.scss";

function Block() {
  return (
    <div className={style.block}>
      <EditableDiv className={style.title} smartProp="title" />
      <EditableDiv
        className={style.list}
        tagName="ul"
        multiline="li"
        smartProp="list"
        placeholder={"Entrez un texte"}
      />
    </div>
  );
}

export default defineBlock({
  Block,
  smartProps: {
    title: smartProps.string.withDefault(""),
    list: smartProps.string.withDefault(""),
  },
  setup: {
    title: "Froid - Description Produit",
    parent: ["smartfire/froid-product-specs-container"],
  },
});
